import { BaseNodeCommand, NodeChangeRecord } from '../../../core/commands/base/BaseNodeCommand';

interface PersonUpdateSpec {
  nodeId: string;
  changes: any;
}

export class BatchUpdatePersonsCommand extends BaseNodeCommand {
  private updates: PersonUpdateSpec[];

  constructor(updates: PersonUpdateSpec[], description?: string) {
    super('Update Persons', description || 'Batch update person nodes');
    this.updates = updates;
  }

  protected doExecute(): NodeChangeRecord[] {
    const mgr = this.getMutationManager();
    const records = (mgr as any).applyBatchNodeChanges(this.updates) as NodeChangeRecord[];
    return records || [];
  }
}


